export class CookieManager
{
	static Cookies = {
		Coupon: {
			Key: "COUPON_v1",
			CouponCode: "CouponCode",
			IsPromomtion: "IsPromotion",
			IsValid: "IsValid",
			LastValidated: "LastValidated",
			CouponID: "CouponID",
			Days: "Days",
			ExpirationDate: "ExpirationDate",
			PreviousCouponID: "PreviousCouponID"
		},
		Currency: {
			Key: "CURRENCY_v1",
			CurrencySymbol: "CurrencySymbol",
			CurrencyID: "CurrencyID",
			CurrencyCode: "CurrencyCode"
		},
		DataPrivacyPolicy:
		{
			Key: "DATAPRIVACYPOLICY_v1",
			MarketingTrackingApproved: "MarketingTrackingApproved",
			PerformanceTrackingApproved: "PerformanceTrackingApproved"
		},
		DelayModal: {
			Key: "delayModal"
		},
		Unique: {
			Key: "UNIQUE"
		},
		RecentItems: {
			Key: "RECENTITEMS_v1",
			RecentItems: "RecentItems"
		},
		ReturnVisitor: {
			Key: "RETURN_v2",
			LastVisitTime: "LastVisitTime",
			Ordered: "Ordered",
			VisitCount: "visitCount"
		},
		SeenModal: {
			Key: "seenModal"
		},
		SmsModalEligible: {
			Key: "smsModalEligible"
		},
		SmsWelcomeCoupon: {
			Key: "smsWelcomeCoupon"
		},
		WelcomeCoupon: {
			Key: "WelcomeCoupon"
		},
		Visitor: {
			Key: "VISITOR_v1",
			DomainProjectID: "DomainProjectID",
			BillCountryID: "BillCountryID",
			CountryID: "CountryID",
			ShipCountryID: "ShipCountryID"
		}
	};

	static KeyValuePairSeparator = "&";

	static GetCookie(cookieName: string, cookieKey?: string)
	{
		let cookieValue = "";
		const allCookies = document.cookie.split(";");

		// need to loop all the cookies to find the one requested
		for (let allCookiesIndex = 0; allCookiesIndex < allCookies.length; allCookiesIndex++)
		{
			const firstEqualSignIndex = allCookies[allCookiesIndex].indexOf("=");
			const currentCookieName = (allCookies[allCookiesIndex].substring(0, firstEqualSignIndex)).replace(/^\s+|\s+$/g, "");

			if (currentCookieName === cookieName)
			{
				// found the name requested
				const currentCookieValue = allCookies[allCookiesIndex].substring(firstEqualSignIndex + 1);

				if (cookieKey !== undefined && cookieKey !== null && cookieKey.length > 0)
				{
					// loop the key value pairs to find the key requested
					const currentCookieValues = currentCookieValue.split(this.KeyValuePairSeparator);

					for (let currentCookieValuesIndex = 0; currentCookieValuesIndex < currentCookieValues.length; currentCookieValuesIndex++)
					{
						const keyValuePair = currentCookieValues[currentCookieValuesIndex].split("=");

						if (keyValuePair[0] === cookieKey)
						{
							// found the key requested
							cookieValue = decodeURIComponent(keyValuePair[1]);
							break;
						}
					}
				}
				else
				{
					cookieValue = decodeURIComponent(currentCookieValue);
				}
				break;
			}
		}
		return cookieValue;
	}

	// fun_dcd && fun_scd are registered to the page from the BaseMasterPage.cs
	static GetCookieDomain()
	{
		let domain = null;

		// @ts-expect-error fun_CookieDomain MIGHT be defined
		if (typeof (fun_CookieDomain) !== "undefined" && fun_CookieDomain !== null && fun_CookieDomain !== "")
		{
			// @ts-expect-errorfun_CookieDomain MIGHT be defined
			domain = fun_CookieDomain;
		}

		return domain;
	}

	static GetCookieNames()
	{
		const cookieNames = [];
		const allCookies = document.cookie.split(";");

		// need to loop all the cookies to find the one requested
		for (let allCookiesIndex = 0; allCookiesIndex < allCookies.length; allCookiesIndex++)
		{
			const firstEqualSignIndex = allCookies[allCookiesIndex].indexOf("=");
			const currentCookieName = (allCookies[allCookiesIndex].substring(0, firstEqualSignIndex)).replace(/^\s+|\s+$/g, "");

			cookieNames.push(currentCookieName);
		}

		return cookieNames;
	}

	static SetCookie(cookieName: string, cookieValue?: string, expirationDays?: number, setDomain = true)
	{
		let expirationDate = null;
		let domain = null;

		if (cookieValue === null || cookieValue === undefined)
		{
			//act as a delete of the cookie by setting the expiration date to a previous time
			expirationDays = -1;
		}

		if (typeof expirationDays === "number")
		{
			if (expirationDays < 1)
			{
				const minutes = expirationDays * 24 * 60;
				const nowDate = new Date();
				expirationDate = new Date(nowDate.getTime() + minutes * 60000);
			}
			else
			{
				expirationDate = new Date();
				expirationDate.setDate(expirationDate.getDate() + expirationDays);
			}
		}

		if (setDomain === true)
		{
			domain = this.GetCookieDomain();
		}

		const secureSetting = (window.location.protocol.indexOf("https:") >= 0 ? ";secure" : "");

		// it is assumed that cookieValue would be URI encoded if it would need to be.
		// this is assumed since there can be multiple values instead of only 1 for this cookie.
		document.cookie = cookieName + "=" + cookieValue + (expirationDate === null ? "" : "; expires=" + expirationDate.toUTCString()) + (domain === null ? "" : "; domain=" + domain) + "; path=/" + secureSetting;
	}

	static SetInCookie(cookieName: string, cookieKey: string, cookieKeyValue: string, expirationDays?: number, setDomain?: boolean)
	{
		let cookieValue = this.GetCookie(cookieName);

		if (cookieValue !== null && cookieValue.length > 0)
		{
			const currentCookieValues = cookieValue.split(this.KeyValuePairSeparator);

			// build the dictionary of existing values
			const dictionary = {};

			for (let currentCookieValuesIndex = 0; currentCookieValuesIndex < currentCookieValues.length; currentCookieValuesIndex++)
			{
				// if it does not have length then it doesn"t belong in the new value.
				if (currentCookieValues[currentCookieValuesIndex].length > 0)
				{
					const keyValuePair = currentCookieValues[currentCookieValuesIndex].split("=");
					dictionary[keyValuePair[0]] = (typeof keyValuePair[1] === "undefined" ? "" : keyValuePair[1]);
				}
			}

			// add/update the value of the cookie key
			dictionary[cookieKey] = encodeURIComponent(cookieKeyValue);

			// clear the current value so it can be re-built.
			cookieValue = "";

			// build the new cookievalue
			let firstKeyAdded = false;

			for (const key in dictionary)
			{
				if (Object.prototype.hasOwnProperty.call(dictionary, key))
				{
					cookieValue += (firstKeyAdded ? this.KeyValuePairSeparator : "") + key + "=" + dictionary[key];
					if (!firstKeyAdded)
					{
						firstKeyAdded = true;
					}
				}
			}
		}
		else
		{
			cookieValue = cookieKey + "=" + encodeURIComponent(cookieKeyValue);
		}
		this.SetCookie(cookieName, cookieValue, expirationDays, setDomain);
	}
}